export default __webpack_public_path__ + "static/media/minus-cirlce.67e88cc7.svg";